.root {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  z-index: 20; //mask is 10
  display: grid;
  grid-template-columns: 1fr 60px;
  grid-template-rows: 1fr;
  pointer-events: none;
  transform: translateX(-100vw);

  .body {
    pointer-events: auto;
    background: #f8f7f4;
    display: flex;
    flex-direction: column;
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
    .menuHeader {
      display: flex;
      height: 60px;
      justify-content: space-around;
      align-items: center;
      padding-left: 16px;
      padding-right: 16px;
      .backBtn {
        font-family: Montserrat;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px;
        letter-spacing: -0.02em;
        text-align: center;
        background: #161a21;
        text-transform: uppercase;
        background-color: transparent;
        border: none;
        flex: 1;
        align-self: stretch;
        display: flex;
        align-items: center;
        color: #161a21;
        .iconleft {
          width: 7px;
          height: 12px;
          margin: 0 0 0 12px;
        }
      }
      .headerSpacer {
        width: 1px;
        height: 30px;

        background: #161a21;
        opacity: 0.15;
      }
      .headerItem {
        cursor: pointer;
        flex: 1;
        text-align: center;
        position: relative;
        height: 100%;
        font-family: Montserrat;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 14px;
        letter-spacing: 0.02em;
        text-align: center;
        display: grid;
        grid-template-rows: 23px 1fr 23px;
        justify-content: center;
        align-items: center;
        .hlIcon {
          align-self: flex-end;
        }
        &.activeItem {
          border-bottom: 2px solid #000;
        }
      }
    }
    .menuSpacer {
      box-sizing: border-box;
      background-color: #161a2133;
      height: 1px;
      margin-left: 16px;
      margin-right: 16px;
    }
    .menuBody {
      flex: 1;
      padding: 36px 32px;
      overflow: auto;
      .menuItem {
        border-bottom: 1px solid #161a2133;
        .menuItemTitle {
          padding: 0;
          padding-top: 24px;
          padding-bottom: 24px;
          font-family: Montserrat;
          font-size: 20px;
          font-style: normal;
          font-weight: 700;
          line-height: 20px;
          letter-spacing: -0.02em;
          text-align: left;
          color: #161a21;
          border: none;
          background-color: transparent;
          width: 100%;
          display: flex;
          align-items: center;
          text-transform: uppercase;
          span {
            flex: 1;
          }
        }
        .menuChildren {
          display: flex;
          gap: 16px;
          padding-bottom: 24px;
          .menuChildItem {
            font-family: Montserrat;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 14px;
            letter-spacing: 0.02em;
            text-align: left;
            color: #161a21;
            text-transform: uppercase;
          }
        }
        .menuRightIcon {
          width: 7px;
          height: 12px;
        }
      }
    }
    .menuFooter {
      padding: 16px;
      .menuFooterBtn {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;
        font-family: Montserrat;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 14px;
        letter-spacing: 0.02em;
        text-align: center;
        text-transform: uppercase;
        color: #161a21;
        text-decoration: none;
        .menuItemIconRight {
          width: 12px;
          height: 6px;
        }
      }
    }
    .menuBodyLeaf {
      @extend .menuBody;
      padding: 32px 24px;
    }
    .bottomNav {
      padding-top: 32px;
      display: grid;
      grid-template-columns: auto;
      grid-auto-flow: row;
      gap: 32px;
      .bottomNavItem {
        display: grid;
        gap: 12px;
        grid-template-columns: 20px 1fr auto;
        justify-content: center;
        align-items: center;
        .bottomNavTitle {
          font-family: Montserrat;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 14px;
          letter-spacing: 0.02em;
          text-align: left;
          text-transform: uppercase;
          text-decoration: none;
          color: #161a21;
        }
        .bottomNavVerticalLine {
          display: block;
          align-self: center;
          justify-self: center;
          background: #161a21;
          opacity: 0.15;
          height: 100%;
          width: 1px;
        }
        .bottomNavItemList {
          display: flex;
          flex-direction: column;
          gap: 20px;
          .bottomNavItemListChild {
            font-family: Montserrat;
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            line-height: 14px;
            letter-spacing: -0.02em;
            text-align: left;
            text-decoration: none;
            color: #161a21;
          }
        }
      }
    }
  }
  .closeBtn {
    pointer-events: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #f8f7f4;
    width: 60px;
    height: 60px;
    box-sizing: border-box;
    border: 1px solid #f8f7f4;
    background-color: transparent;
    border-left: 0;
  }
}
.maskRoot {
  z-index: 18;
  border: none;
  background-color: transparent;
}
.maskRootActive {
  background-color: black;
  opacity: 0.8;
}
